<template>
  <b-form
    @submit.prevent="submit"
    v-shortkey="['ctrl', 'enter']"
    @shortkey="submit()"
  >
    <slot></slot>
  </b-form>
</template>

<script>
  import { BForm } from 'bootstrap-vue';

  export default {
    components: {
      BForm
    },
    props: {
      readonly: {},
      form: {},
      bypass: {},
      disabled: {},
      message: {
        type: String,
        default: 'alert.unableToRevertAfterSave'
      },
      confirmButtonText: {
        type: String,
        default: 'button.yesSaveChanges'
      },
      cancelButtonText: {
        type: String,
        default: 'button.cancel'
      }
    },
    methods: {
      submit() {
        if (this.readonly || this.disabled || this.bypass) {
          this.$emit('submit');
          return;
        }
        
        this.confirm();
      },
      confirm() {
        this.$bvModal
          .msgBoxConfirm(this.$t(this.message), {
            title: this.$t('alert.confirmContinueOperation'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: this.$t(this.confirmButtonText),
            cancelTitle: this.$t(this.cancelButtonText),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              this.$emit('submit');
            }
          });
      }
    }
  };
</script>

<style scoped></style>
